
const addWorkingDays = (endDate, duration) => {
    const resultDate = new Date(endDate);

    while (duration > 0) {
        resultDate.setDate(resultDate.getDate() + 1);

        const day = resultDate.getDay();

        if (day !== 0 && day !== 6)
            duration--;
    }

    return resultDate;
};

const subtractWorkingDays = (endDate, duration) => {
    const resultDate = new Date(endDate);

    while (duration > 0) {
        resultDate.setDate(resultDate.getDate() - 1);

        const day = resultDate.getDay();

        if (day !== 0 && day !== 6)
            duration--;
    }

    return resultDate;
};

const fixEndDate = (endDate) => {
    const fixedEndDate = new Date(endDate);

    const day = fixedEndDate.getDay();

    if (day === 6)
        fixedEndDate.setDate(fixedEndDate.getDate() + 2);
    else if (day === 0)
        fixedEndDate.setDate(fixedEndDate.getDate() + 1);

    return fixedEndDate;
};

const getWorkingDaysDifference = (oldEndDate, newEndDate) => {
    let oldDate = new Date(oldEndDate);

    let newDate = new Date(newEndDate);

    let sign = 1;
  
    if (oldDate > newDate) {
      [oldDate, newDate] = [newDate, oldDate];
      sign = -1;
    }
  
    let count = 0;
    
    while (oldDate < newDate) {
      const day = oldDate.getDay();

      if (day !== 0 && day !== 6)
        count++;
      
      oldDate.setDate(oldDate.getDate() + 1);
    }
  
    return count * sign;
};

const modifyEndDate = (endDate, workingDaysDifference) => {
    let newEndDate;

    const absoluteWorkingDaysDifference = Math.abs(workingDaysDifference);

    if (workingDaysDifference < 0)
        newEndDate = subtractWorkingDays(endDate, absoluteWorkingDaysDifference);

    else if (workingDaysDifference > 0)
        newEndDate = addWorkingDays(endDate, absoluteWorkingDaysDifference);

    else newEndDate = endDate;

    return newEndDate;
};


module.exports = {
    addWorkingDays,
    subtractWorkingDays,
    fixEndDate,
    getWorkingDaysDifference,
    modifyEndDate
};